import React from 'react';
// Components
import FaqSectionOne from './FaqSectionOne';
import FaqSectionTwo from './FaqSectionTwo';
import CallToActionOne from '../cta/CallToActionOne';
import SmallGalleryComponent from '../gallery/SmallGalleryComponent';

function FaqMainContainer() {
  return (
    <main
      role='main'
      className='grid top_shadow pt-28 w-full h-full overflow-hidden full_shadow_black_invert'
    >
      <div className='grid gap-10 lg:w-[70%] lg:mx-auto px-2'>
        {/* Faq sections */}
        <FaqSectionOne />
      </div>

      {/* Cta */}
      <div className='py-12 lg:py-16'>
        <CallToActionOne />
      </div>

      {/* Section two */}
      <div className='grid gap-10 lg:w-[70%] lg:mx-auto px-2'>
        <FaqSectionTwo />
      </div>

      {/* Gallery  */}
      <div className='py-12 lg:py-16'>
        <div className='grid w-full h-full bg-colour3 dark:bg-colour3 py-6 lg:py-10 lg:px-10 full_shadow_black_invert'>
          <SmallGalleryComponent />
        </div>
      </div>
    </main>
  );
}

export default FaqMainContainer;
